import {
	ADD_PREVIEW_WIDGET,
	UPDATE_PREVIEW_WIDGET,
	SET_PREVIEW_WIDGETS,
	DELETE_PREVIEW_WIDGET
} from "../../actions/DashboardDesigner/actionContants";

const previewWidgets = (state = [], action) => {
	switch (action.type) {
		/**
		 * action: {
		 *  type:
		 *  widget:
		 * }
		 */
		case ADD_PREVIEW_WIDGET:
			return [...state, action.widget];
		/**
		 * action: {
		 *  type:
		 *  payload:
		 *  widgetId:
		 * }
		 */
		case UPDATE_PREVIEW_WIDGET:
			var { widgetId, payload } = action;
			let targetWidgetObj = state.find(e => e.id === widgetId);
			let updatedWidgetObj = { ...targetWidgetObj, ...payload };
			return state.map(widget => {
				if (widget.id === widgetId) {
					return updatedWidgetObj;
				} else {
					return { ...widget };
				}
			});
		/**
		 * action: {
		 *  widgetId:
		 * }
		 */
		case DELETE_PREVIEW_WIDGET:
			var { widgetId } = action;
			return state.filter(widget => widget.id !== widgetId);
		case SET_PREVIEW_WIDGETS:
			return action.data;
		default:
			return state;
	}
};

export default previewWidgets;
